module.exports = __webpack_public_path__ + "img/T1D_rc-20.6c0265b8.png";